export function shortChangeSetId(changeSetId: string) {
  return changeSetId.length <= 12 ? changeSetId : changeSetId.slice(0, 8);
}

export function compactDateTime(value: string) {
  try {
    return new Intl.DateTimeFormat(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(new Date(value));
  } catch {
    return value;
  }
}
